export interface IBaryModalEvent {
  first: boolean | undefined;
  second: boolean | undefined;
  next: boolean | undefined;
  back: boolean | undefined;
  close: boolean | undefined;
  cancel: boolean | undefined;
  submit: boolean | undefined;
  failure: boolean | undefined;
  value: any;
}

export class BaryModalEvent implements IBaryModalEvent {
  close: boolean | undefined;
  first: boolean | undefined;
  second: boolean | undefined;
  back: boolean | undefined;
  cancel: boolean | undefined;
  next: boolean | undefined;
  submit: boolean | undefined;
  failure: boolean | undefined;
  value: any;

  constructor({ first, second, next, back, close, cancel, submit, failure, value }: any) {
    this.first = first;
    this.second = second;
    this.close = close;
    this.value = value;
    this.submit = submit;
    this.next = next;
    this.back = back;
    this.cancel = cancel;
    this.failure = failure;
  }
}
